import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA } from '../../constants/onboarding-state/onboarding-constants';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql';

export const preloadLandUsersInEditorWithRevampedBpqa = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: [...Object.values(LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA)],
		},
	});
};
